const { host } = window.location;

export const isAcademyDomain = !!host.match(/(academy-(\w+)|academy)\.guesty\.com/);
